<template>
  <div class="sm:col-span-2 grid grid-cols-2 gap-x-4">
    <div class="col-span-1">
      <vetster-input-group :label="$t('app.time-from')">
        <vetster-select
          v-model.trim="inputs.time_from"
          :options="fromOptions"
          @update:modelValue="$emit('selected')"
        />
      </vetster-input-group>
    </div>
    <div class="col-span-1">
      <vetster-input-group :label="$t('app.time-to')">
        <vetster-select
          v-model.trim="inputs.time_to"
          :options="toOptions"
          @update:modelValue="$emit('selected')"
        />
      </vetster-input-group>
    </div>
  </div>
</template>

<script>
import filter from 'lodash/filter';
import { DateTime } from 'luxon';
import { mapState } from 'vuex';

import VetsterInputGroup from '@/components/VetsterInputGroup';
import VetsterSelect from '@/components/VetsterSelect';
import { i18n } from '@/i18n';

export default {
  name: 'VetsterTimeFramePicker',

  components: {
    VetsterInputGroup,
    VetsterSelect,
  },

  computed: {
    ...mapState('search', ['inputs']),

    fromOptions() {
      return filter(this.getTimeOptions, (time) => {
        if (!this.inputs.time_to && this.inputs.time_to !== 0) {
          return true;
        }

        return this.inputs.time_to > time.value;
      });
    },
    toOptions() {
      return filter(this.getTimeOptions, (time) => {
        if (!this.inputs.time_from && this.inputs.time_from !== 0) {
          return true;
        }

        return this.inputs.time_from < time.value;
      });
    },
    getTimeOptions() {
      const options = [];
      let newDate = DateTime.local().startOf('day');
      while (newDate <= DateTime.local().endOf('day')) {
        options.push({
          value: Number(
            newDate
              .setLocale(i18n.locale)
              .toLocaleString({
                hour: '2-digit',
                minute: '2-digit',
                hourCycle: 'h23',
              })
              .match(/\d|\.|-/g)
              .join(''),
          ),
          text: newDate
            .setLocale(i18n.locale)
            .toLocaleString(DateTime.TIME_SIMPLE),
        });
        if (newDate.plus({ minutes: 30 }) > DateTime.local().endOf('day')) {
          newDate = newDate.plus({ minutes: 29 });
        } else {
          newDate = newDate.plus({ minutes: 30 });
        }
      }

      return options;
    },
  },
};
</script>
